const doc = [({"ja":({"labelTop":({"lastname":"姓", "firstname":"名", "email":"メールアドレス", "phone":"電話番号", "company":"会社名"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;